import type { DynamicClient, NetworkData } from '@dynamic-labs-sdk/client';
import { createBaseNetworkProvider } from '@dynamic-labs-sdk/client/core';

import type { EvmNetworkProvider } from '../../EvmNetworkProvider';
import { fetchEvmBalance } from '../fetchEvmBalance';

/** @not-instrumented */
export const createEvmNetworkProvider = (
  networkData: NetworkData,
  client: DynamicClient
): EvmNetworkProvider => ({
  ...createBaseNetworkProvider('EVM', networkData),

  getBalance: async ({ address }) => ({
    balance: await fetchEvmBalance(
      {
        address,
        networkData,
      },
      client
    ),
  }),
});
